import React from "react";

import { useQuery } from "@apollo/client";

import panelEventsQuery from "./panel-events-query";
import LiveDataTable from "./livedata-table-mui";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
  // startDate: number; // Date;
  // endDate: number; // Date;
  // widgetStatic?: boolean;
  // widgetTitle?: string;
}

function PanelEventsContainer(props: Props) {
  const {
    nodes,
    panelCollectionName,
    // panelId,
    panelDefinition,
    // startDate,
    // endDate,
    // widgetStatic,
    // widgetTitle,
  } = props;
  const n = nodes ? nodes.join(",") : undefined;
  const { data, error, loading } = useQuery(panelEventsQuery, {
    variables: {
      panelName: panelDefinition?.template,
      panelCollectionName: panelCollectionName,
      tab: panelDefinition?.id,
      node: n,
      // view: "statistic",
    },
  });
  // console.log("iconLink data", data);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  if (!data?.events || data.events.length === 0) {
    return <></>;
  }

  const newTable = {
    columns: [
      {
        number: 0,
        headerData: {
          content: "eventIcon",
          headerTitle: " ", // TODO headerTitle is not an "official" property
        },
      },
      {
        number: 1,
        headerData: {
          content: "formattedEndDate",
          headerTitle: "End Date", // TODO headerTitle is not an "official" property
        },
      },
      {
        number: 2,
        headerData: {
          content: "message",
          headerTitle: "Comments", // TODO headerTitle is not an "official" property
        },
      },
    ],
    rowData: data.events.map((c: any) => [
      {
        image: c.eventIcon,
        hasImage: true,
      },
      {
        content: c.formattedEndDate,
      },
      {
        content: c.message,
      },
    ]),
  };
  return (
    <LiveDataTable
      metaData={newTable}
      tableColumnExtensions={[
        { columnName: "eventIcon", align: "left", width: 70 },
        { columnName: "formattedEndDate", width: 200 },
      ]}
    />
  );
}

export default PanelEventsContainer;
